/**
 * Route definition for /signin
 * Renders the SignInContainer component.
 *
 * @module routes/signin
 * @category Routes
 */
import { createFileRoute } from '@tanstack/react-router'
import SignInContainer from '@/containers/SignIn'

export const Route = createFileRoute('/$locale/signin')({
  component: SignIn,
})

/**
 * Sign in page component.
 * Renders the SignIn container for user authentication.
 *
 * @returns {React.ReactElement}
 */
function SignIn() {
  return (
    <>
      <SignInContainer />
    </>
  )
}